export const FIELD_OPTIONS: string[] = [
  'File name',
  'Actuality',
  'Period',
  'Group'
];

export const OPERATOR_OPTIONS: string[] = [
  'contains',
  'is',
  'starts with',
  'ends with'
];

export const actualityOptions: string[] = ['AA', 'AM'];

export const periodOptions: string[] = [
  '2003',
  '2006',
  '2009',
  '2012',
  '2103',
  '2106',
  '2109',
  '2112',
  '2203',
  '2206',
  '2209',
  '2212',
  '2303',
  '2306',
  '2309',
  '2312',
  '2403',
  '2406',
  '2409',
  '2412',
  '2503',
  '2506',
  '2509',
  '2512',
  '2603'
];

export const groupOptions: string[] = [
  'ITA',
  'UK',
  'DE',
  'AT',
  'CH',
  'A1000'
];
